import { PlayerBundleId, AccountId, PlayerBundle__AccountType } from "@ollie-sports/models";
import _ from "lodash";
import { updatedLinkedTeamsForPlayerBundleId } from "./helpers/updatedLinkedTeamsForPlayerBundleId";
import * as express from "express";
import { validateToken } from "../../internal-utils/server-auth";
import { getUniversalHelpers } from "../../helpers";

export async function playerBundle__server__addManagedAccount(p: {
  playerBundleId: PlayerBundleId;
  managedAccountId: AccountId;
  type: PlayerBundle__AccountType;
}) {
  // SERVER_ONLY_TOGGLE
  const { ollieFirestoreV2: h } = getUniversalHelpers();
  const playerBundle = await h.PlayerBundle.getDoc(p.playerBundleId);

  if (!playerBundle) {
    throw new Error("Unable to find playerBundle");
  }

  if (playerBundle.managingAccounts?.[p.managedAccountId]) {
    throw new Error(
      `An account already manages this playerBundle PlayerBundleId: ${p.playerBundleId} . ManagedAccountId: ${p.managedAccountId} `
    );
  }

  await h.PlayerBundle.update({
    id: p.playerBundleId,
    doc: { managingAccounts: { [p.managedAccountId]: { exists: true, type: p.type } } }
  });
  return await updatedLinkedTeamsForPlayerBundleId({ playerBundleId: p.playerBundleId });
  // SERVER_ONLY_TOGGLE
}

playerBundle__server__addManagedAccount.auth = async (r: express.Request) => {
  await validateToken(r);
};

// i18n certified - complete
